// js/custom-element/behavior/scroll-spy.js
(function() {
  const init = function() {
    if (!window.customElements.get("scroll-spy")) {
      var ScrollSpy = class extends HTMLElement {
        connectedCallback() {
          this._createSvg();
          this.elementsToObserve = Array.from(this.querySelectorAll("a")).map((linkElement) => document.querySelector(linkElement.getAttribute("href")));
          this.navListItems = Array.from(this.querySelectorAll("li"));
          this.navItems = this.navListItems.map((listItem) => {
            const anchor = listItem.firstElementChild, targetID = anchor && anchor.getAttribute("href").slice(1), target = document.getElementById(targetID);
            return { listItem, anchor, target };
          }).filter((item) => item.target);
          this.drawPath();
          window.addEventListener("scroll", window.throttle(this.markVisibleSection.bind(this), 25));
          window.addEventListener("orientationchange", () => {
            window.addEventListener("resize", () => {
              this.drawPath();
              this.markVisibleSection();
            }, { once: true });
          });
          this.markVisibleSection();
        }
        _createSvg() {
          this.navPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
          const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          svgElement.insertAdjacentElement("beforeend", this.navPath);
          this.insertAdjacentElement("beforeend", svgElement);
          this.lastPathStart = this.lastPathEnd = null;
        }
        drawPath() {
          let path = [], pathIndent;
          this.navItems.forEach((item, i) => {
            const x = item.anchor.offsetLeft - 5, y = item.anchor.offsetTop, height = item.anchor.offsetHeight;
            if (i === 0) {
              path.push("M", x, y, "L", x, y + height);
              item.pathStart = 0;
            } else {
              if (pathIndent !== x) {
                path.push("L", pathIndent, y);
              }
              path.push("L", x, y);
              this.navPath.setAttribute("d", path.join(" "));
              item.pathStart = this.navPath.getTotalLength() || 0;
              path.push("L", x, y + height);
            }
            pathIndent = x;
            this.navPath.setAttribute("d", path.join(" "));
            item.pathEnd = this.navPath.getTotalLength();
          });
        }
        syncPath() {
          const someElsAreVisible = () => this.querySelectorAll(".is-visible").length > 0, thisElIsVisible = (el) => el.classList.contains("is-visible"), pathLength = this.navPath.getTotalLength();
          let pathStart = pathLength, pathEnd = 0;
          this.navItems.forEach((item) => {
            if (thisElIsVisible(item.listItem)) {
              pathStart = Math.min(item.pathStart, pathStart);
              pathEnd = Math.max(item.pathEnd, pathEnd);
            }
          });
          if (someElsAreVisible() && pathStart < pathEnd) {
            if (pathStart !== this.lastPathStart || pathEnd !== this.lastPathEnd) {
              const dashArray = `1 ${pathStart} ${pathEnd - pathStart} ${pathLength}`;
              this.navPath.style.setProperty("stroke-dashoffset", "1");
              this.navPath.style.setProperty("stroke-dasharray", dashArray);
              this.navPath.style.setProperty("opacity", "1");
            }
          } else {
            this.navPath.style.setProperty("opacity", "0");
          }
          this.lastPathStart = pathStart;
          this.lastPathEnd = pathEnd;
        }
        markVisibleSection() {
          this.navListItems.forEach((item) => item.classList.remove("is-visible"));
          for (const [index, elementToObserve] of this.elementsToObserve.entries()) {
            const boundingClientRect = elementToObserve.getBoundingClientRect();
            if (boundingClientRect.top > window.getStickyHeaderOffset() || index === this.elementsToObserve.length - 1) {
              this.querySelector(`a[href="#${elementToObserve.id}"]`).parentElement.classList.add("is-visible");
              break;
            }
          }
          this.syncPath();
        }
      };
      window.customElements.define("scroll-spy", ScrollSpy);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();